import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { Card } from "../Card";
import { Portal } from "../Portal";

import "./styles.scss";

export const Modal = ({ cardClassName, children, className, show, ...props }) => (
  <Portal>
    <div className={createClassNameString(["apti-Modal", show ? "show" : undefined, className])}>
      <Card className={createClassNameString([cardClassName, "apti-Modal__dialog"])} {...props}>
        {children}
      </Card>
    </div>
  </Portal>
);

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  show: PropTypes.bool,
};

Modal.defaultProps = {
  children: <></>,
  className: undefined,
  show: false,
};
